import React from 'react'
import BanAgentTable from './BanAgentTable'

const BanAgent = () => {
  return (
    <div>
      <BanAgentTable />
    </div>
  )
}

export default BanAgent